import React from 'react';

export const SectionRow = ({
  label,
  htmlFor,
  description,
  children,
  rightAlign = false,
}: {
  label: string;
  htmlFor?: string;
  description?: React.ReactNode;
  children: React.ReactNode;
  rightAlign?: boolean;
}) => (
  <div className="flex flex-col gap-4 border-b border-[var(--base-border,#3d3d3d)] py-6 last:border-0 sm:flex-row sm:items-center sm:justify-between">
    <div className="pr-4 sm:w-[40%] md:w-[45%]">
      {htmlFor ? (
        <label htmlFor={htmlFor} className="block text-sm font-medium text-[var(--text-dark-primary,#fff)]">
          {label}
        </label>
      ) : (
        <div className="text-sm font-medium text-[var(--text-dark-primary,#fff)]">{label}</div>
      )}
      {description && (
        <div className="mt-1 text-[13px] text-[var(--text-dark-secondary,rgba(255,255,255,0.7))]">
          {description}
        </div>
      )}
    </div>
    <div
      className={`flex items-center sm:w-[60%] md:w-[65%] ${rightAlign ? 'justify-end' : 'justify-start'}`}
    >
      <div className={rightAlign ? '' : 'w-full max-w-[480px]'}>{children}</div>
    </div>
  </div>
);
